export default function CasinoAtmosphere({ activeTab }) {
  return (
    <div className="vl-atmosphere" data-scene={activeTab} aria-hidden="true">
      <div className="vl-atmosphere__ship-cinema" />
      <div className="vl-atmosphere__storm-clouds" />
      <div className="vl-atmosphere__moon-path" />
      <div className="vl-atmosphere__ocean" />
      <div className="vl-atmosphere__wave vl-atmosphere__wave--near" />
      <div className="vl-atmosphere__wave vl-atmosphere__wave--far" />
      <div className="vl-atmosphere__lantern-glow vl-atmosphere__lantern-glow--left" />
      <div className="vl-atmosphere__lantern-glow vl-atmosphere__lantern-glow--right" />
      <div className="vl-atmosphere__aurora vl-atmosphere__aurora--one" />
      <div className="vl-atmosphere__aurora vl-atmosphere__aurora--two" />
      <div className="vl-atmosphere__ship-lines" />
      <div className="vl-atmosphere__embers">
        {Array.from({ length: 12 }, (_, index) => (
          <span key={index} style={{ '--ember-index': index }} />
        ))}
      </div>
      <div className="vl-atmosphere__coins">
        {Array.from({ length: 7 }, (_, index) => (
          <span key={index} style={{ '--coin-index': index }}><b>$</b></span>
        ))}
      </div>
      <div className="vl-atmosphere__notes">
        {Array.from({ length: 4 }, (_, index) => (
          <span key={index} style={{ '--note-index': index }}>$</span>
        ))}
      </div>
      <div className="vl-atmosphere__grain" />
    </div>
  );
}
